import { render, staticRenderFns } from "./Endereco.vue?vue&type=template&id=b3607b7a&scoped=true"
import script from "./Endereco.vue?vue&type=script&lang=js"
export * from "./Endereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3607b7a",
  null
  
)

export default component.exports